import styled, { css } from 'styled-components'
import { colors } from 'modules/app/styles'
import { CONSTANTS } from 'utils/helpers'

export const MainMenu = styled.div`
  background: #fff;
  position: fixed;
  @media (min-width: 576px) {
    position: fixed;
  }
  z-index: ${props => props.isFullScreen ? `3000000000000` :`20`};
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  border-right: 1px solid #e3e4ed;
  @media (min-width: 576px) {
    width: ${CONSTANTS.mainMenuMinWidth}px;
    min-width: ${CONSTANTS.mainMenuMinWidth}px;
  }
  div.logo {
    margin-top: 0;
    padding: 13px 14px;
    border-bottom: 1px solid ${colors['light-blue-200']};
    height: 72px;
    display: flex;
    align-items: center;
    img {
      width: auto;
      height: 25px;
      border-radius: 5px;
    }
    a {
      display: flex;
      align-items: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      width: inherit;
      height: inherit;
      
      .company-name {
        font-size: 23px;
        font-weight: bold;
      }
      .has-company-logo {
        margin-right: 10px;
        min-width: 45px;
        max-width: 45px;
        height: 45px;
        display: flex;
        align-tems: center;
        justify-content: center;
        overflow: hidden;
        img {
          height: 100%;
        }
      }
    }
  }
  transition: transform 0.35s ease-out;
  transform: translateX(-100%);
  &.open {
    transform: translateX(0);
  }
`

export const MenuItems = styled.ul`
  width: 100%;
  height: 47px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  list-style: none;
  z-index: 2;
  border-bottom: 1px solid ${colors['light-blue-200']};
  margin-bottom: 0;

  li {
    width: auto;
    text-align: center;
    padding: 12px 16px;
    width: 50%;
    font-size: 14px;
    color: #000;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.7;
    filter: grayscale(1);
    border-bottom: 2px solid transparent;
    &:first-of-type {
      border-right: 1px solid ${colors['light-blue-200']};
    }
    .title {
      display: block;
      margin-left: 6px;
    }
    &:hover,
    &.active {
      filter: none;
      opacity: 1;
      font-weight: 600;
    }
    &.active {
      border-bottom-color: ${colors['main-blue']};
    }
    .icon svg {
      width: 20px;
      height: 20px;
    }
  }
`

export const MenuDrawerContent = styled.div`
  height: calc(100% - 119px);
  width: 100%;
  /* overflow: hidden; */
`

export const SearchBox = styled.div`
  width: 100%;
  padding: 12px 16px 0;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  .searchIcon {
    position: absolute;
    top: 17px;
    left: 21px;
  }
  .SearchInput {
    width: 100%;
    height: 32px;
    padding: 7px;
    padding-left: 30px;
    border-radius: 15px;
    font-size: 14px;
    background: ${colors['lightest-blue']};
    -webkit-text-fill-color: ${colors['text-secondary']};
    color: ${colors['text-secondary']};
    border: 1px solid #c8d1e6;
    &:focus {
      outline: none;
    }
  }
`
export const TopBar = styled.div`
  background-image: linear-gradient(to right, rgb(0 0 0), rgb(10 146 187));
  padding: 1px 10px;
  font-size: 12px;
  height: 30px;
  width: 100%;
  .heading {
    color: #dbe7f9;
    text-align: left;
    width: 60%;
    display: inline-block;
  }

  .heading p {
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .upgrade-btn {
    color: #ffffff;
    text-align: right;
    width: 40%;
    display: inline-block;
    font-weight: 600;
    cursor: pointer;
  }
`
export const ToggleMenuButton = styled.button`
  border: none;
  background: #fff;
  position: absolute;
  top: 15px;
  @media (min-width: 768px) {
    top: 18px;
  }
  right: -50px;
  z-index: 20;
  padding: 0;
  border-radius: 20px;
  transition: right 0.35s ease-out;
  border: 1px solid #e3e4ed;
  ${(props) =>
    props.open
      ? css`
          transform: translateX(-50%) rotate(0);
          right: 0;
          @media (min-width: 576px) {
            right: -33px;
          }
        `
      : css`
          transform: rotate(180deg);
        `}
  svg {
    width: 32px;
    height: 32px;
    stroke: ${colors.gray};
  }
`

export const Resizable = styled.div`
  position: absolute;
  right: -10px;
  top: 50%;
  width: 30px;
  height: 8px;
  background: ${colors['light-blue-200']};
  cursor: col-resize;
  border-radius: 3px;
  transform: translateY(-50%) rotate(90deg);
  display: none;
  @media (min-width: 576px) {
    display: flex;
  }
  align-items: center;
  justify-content: center;

  svg {
    stroke: #fff;
  }
`

export const MainmenuUpgradeButton = styled.div`
  display: none;
  pointer-events: all;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  background: #ededf29e;
  padding: 5px;
  border-radius: 4px;
`

export const CreateItemPopupTitle = styled.div`
  font-family: 'PT Serif';
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  text-align: center;
`

export const CreateItemPopupSubTitle = styled.div`
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 400;
  margin-top: 4px;
  margin-bottom: 24px;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #7f82a2;
`

export const CreateItemBoxOuter = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.isPopup ? 'center' : 'flex-start')};
  gap: 16px;
  flex-direction: column;
  @media (min-width: 992px) {
    flex-direction: row;
  }
`
export const CreateItemBox = styled.div`
  border: 1px solid ${colors['light-blue-200']};
  border-radius: 7px;
  width: 340px;
  height: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 10px 16px;
  .type-name {
    font-weight: 600;
    font-size: 18px;
    line-height: 140%;
    margin-top: 5px;
  }
  .type-text {
    font-size: 14px;
    line-height: 150%;
    margin-bottom: 48px;
  }
`

export const DashboardLeft = styled.div`
  margin: 0 auto;
  position: relative;
  z-index: 1;
  flex: 1;
  max-width: 1100px;
  padding: 0 15px;
  @media (min-width: 576px) {
    padding: 0 26px;
  }
`
